import { render, staticRenderFns } from "./detail-add-or-update.vue?vue&type=template&id=3c0be0c5"
import script from "./detail-add-or-update.vue?vue&type=script&lang=js"
export * from "./detail-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports